import type { GalleryImage } from '@Atomic/molecules/FullscreenGallery';

/**
 * The slide the gallery opens on: the primary photo when the offer has several.
 * Shared by the SSR placeholder and the carousel so both show the same photo.
 */
export const getInitialSlide = (images: GalleryImage[], primaryId?: number): number => {
  if (!primaryId || images.length < 2) {
    return 0;
  }

  const slideIndex = images.findIndex(({ id }) => id === primaryId);

  return slideIndex !== -1 ? slideIndex : 0;
};
